<template>
  <section id="exp" class="container">
    <h1 class="title fourtitle">學員心得</h1>
    <article class="content">
      <h1 class="subtitle bluecar">學員：藍藍路</h1>
      <p>去年被朋友洗腦就跳進了這個無底洞oωo 本身是資訊新手，不過課程不會深到要有多厚的底子才會懂。營隊裡面有個機制是蒐集點數，常常只要達成某個日常小任務就可以拿到。點數可以在黑客松的時候換零食＆在最後的閉幕換奇怪的禮物ww在黑客松中大家一起分工（熬夜）做出成品的時候真的蠻感動的，好像體驗到了工程師的生活，卻感到特別溫馨XD整隊就像一個小家庭，各種互助OAO</p>
      <p>參加這個夏令營能帶走的或許不是各種專業的技術，但真的可以學到不少經驗。想入坑的快來參加今年的營隊r ٩(๑•̀ω•́๑)۶</p>
    </article>
    <article class="content">
      <h1 class="subtitle redcar">學員：Pin Lin</h1>
      <p>去年暑假被朋友推入了 SITCON 開源鄉，做了四天三夜的夢—在夢中我參加了一個由對資訊技術有興趣、想讓更多人認識開源的人們籌辦的夏令營。然而，這跟普通的大學營隊很不一樣，活動與課程的適當搭配讓我在體驗活動的同時一邊學習：共同課程的 Git 讓我得以把自己的程式碼上傳到 GitHub，讓我感受到開源界的互助精神，能向世界貢獻出自己的程式碼也讓我感到異常的興奮；雙軌課程中的前端學員跟後端學員合作，在最後的黑客松一起合作產出最後的成品，讓我體會到團隊合作可以讓一件事變得不再艱難。過程中看見了每個鄉民的真心投入，真的讓我十分的感動，心中彷彿也多了一股對開源鄉的認同感。要是下次在路上又看見通往開源鄉的坑，我一定會毫不猶豫把我的朋友通通推進去。</p>
    </article>
  </section>
</template>
<script>
export default {
  name: 'Exp'

}
</script>
<style lang="stylus">
#exp
  .redcar
    text-align: center
    &:before
      content: ''
      vertical-align: -20%;
      display: inline-block
      background-image: url('../assets/red-car.svg')
      background-size: contain
      background-repeat: no-repeat
      background-position: center
      width: 3rem
      height: 1.6rem
      position: absolute
      margin-left: -3.5rem
      margin-top: 0.2rem
      z-index: 1
  .bluecar
    text-align: center
    &:before
      content: ''
      vertical-align: -20%;
      display: inline-block
      background-image: url('../assets/blue-car.svg')
      background-size: contain
      background-repeat: no-repeat
      background-position: center
      width: 3rem
      height: 1.6rem
      position: absolute
      margin-left: -3.5rem
      margin-top: 0.2rem
      z-index: 1

  .fourtitle
    position: relative
    margin-bottom: 4rem
    &:before
      content: ''
      display: inline-block
      background-image: url('../assets/fourTitle.svg')
      background-size: contain
      background-repeat: no-repeat
      background-position: center
      width: 20rem
      max-width: 90vw
      height: 6rem
      position: absolute
      top: 50%
      left: 50%
      z-index: 1
      transform: translate(-50%, -50%)
      margin-left: -2.5rem
</style>



// WEBPACK FOOTER //
// Exp.vue?4caea705